<template>
  <div id="testing" class="page-layout__inner">
    <div class="page-layout__row  row">
      <div class="col-sm-6">
        <div v-if="testing.id" class="page-layout__group-2">
          <section class="section">
            <div class="section__header">
              <h3 class="card-post__title  section__title">{{ getTranslation('generalInfo') }}</h3>
            </div>
            <div class="section__body">
              <table class="table-doc">
                <tbody>
                <tr>
                  <th class="table-doc__cell  table-doc__cell--head">{{ getTranslation('title') }}:</th>
                  <td class="table-doc__cell">{{ testing.titleRu }}</td>
                </tr>
                <tr>
                  <th class="table-doc__cell  table-doc__cell--head">{{ getTranslation('titleKy') }}:</th>
                  <td class="table-doc__cell">{{ testing.titleKy }}</td>
                </tr>
                <tr>
                  <th class="table-doc__cell  table-doc__cell--head">{{ getTranslation('documentCode') }}:</th>
                  <td class="table-doc__cell">{{ testing.documentCode }}</td>
                </tr>
                <tr>
                  <th class="table-doc__cell  table-doc__cell--head">{{ getTranslation('status') }}:</th>
                  <td class="table-doc__cell">{{ testing.statusTitle }}</td>
                </tr>
                <tr>
                  <th class="table-doc__cell  table-doc__cell--head">{{ getTranslation('questionMinLimit') }}:</th>
                  <td class="table-doc__cell">{{ testing.minLimit }}</td>
                </tr>
                <tr>
                  <th class="table-doc__cell  table-doc__cell--head">{{ getTranslation('questionCount') }}:</th>
                  <td class="table-doc__cell">{{ testing.questionCount }}</td>
                </tr>
                <tr>
                  <th class="table-doc__cell  table-doc__cell--head">{{ getTranslation('type') }}:</th>
                  <td class="table-doc__cell"><span v-if="testing.type">{{ testing.type.title }}</span></td>
                </tr>
                </tbody>
              </table>
            </div>
          </section>
        </div>
      </div>
      <div class="col-sm-6">
        <div v-if="testing.requisites" class="page-layout__group-2">
          <section class="section">
            <div class="section__header">
              <h3 class="card-post__title  section__title">{{ getTranslation('documentRequisites') }}</h3>
            </div>
            <div class="section__body">
              <table class="table-doc">
                <tbody>
                <tr>
                  <th class="table-doc__cell  table-doc__cell--head">{{ getTranslation('title') }}:</th>
                  <td class="table-doc__cell">{{ testing.requisites.Name }}</td>
                </tr>
                <tr>
                  <th class="table-doc__cell  table-doc__cell--head">{{ getTranslation('documentType') }}:</th>
                  <td class="table-doc__cell">{{ testing.requisites.Type }}</td>
                </tr>
                <tr>
                  <th class="table-doc__cell  table-doc__cell--head">{{ getTranslation('documentCode') }}:</th>
                  <td class="table-doc__cell">{{ testing.requisites.Code }}</td>
                </tr>
                <tr>
                  <th class="table-doc__cell  table-doc__cell--head">{{ getTranslation('dateAdopted') }}:</th>
                  <td class="table-doc__cell">{{ dateFormat(testing.requisites.DateAdopted) }}</td>
                </tr>
                <tr v-if="testing.requisites.DateLimit">
                  <th class="table-doc__cell  table-doc__cell--head">{{ getTranslation('dateLimit') }}:</th>
                  <td class="table-doc__cell">{{ dateFormat(testing.requisites.DateLimit) }}</td>
                </tr>
                <tr>
                  <th class="table-doc__cell  table-doc__cell--head">{{ getTranslation('status') }}:</th>
                  <td class="table-doc__cell">{{ testing.requisites.Status }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </section>
        </div>
      </div>
      <div class="col-md-12">
        <section class="tabs-3">
          <ul class="nav  tabs-3__nav  tabs-3__hor-nav">
            <li v-if="hasPermission('api.testing.profile.questions')" class="tabs-3__nav-item">
              <a @click="tabSelect('questions')" :class="'tabs-3__nav-link' + (tabs.questions ? ' active' : '')" href="javascript:void(0)">{{ getTranslation('questions') }}</a>
            </li>
            <li v-if="hasPermission('api.testing.profile.positions') && testing.typeId && testing.typeId === TEST_TYPE_LAW" class="tabs-3__nav-item">
              <a @click="tabSelect('positions')" :class="'tabs-3__nav-link' + (tabs.positions ? ' active' : '')" href="javascript:void(0)">{{ getTranslation('positions') }}</a>
            </li>
            <li v-if="hasPermission('api.testing.profile.nrkPositions')" class="tabs-3__nav-item">
              <a @click="tabSelect('nrkPositions')" :class="'tabs-3__nav-link' + (tabs.nrkPositions ? ' active' : '')" href="javascript:void(0)">{{ getTranslation('nrkResources') }}</a>
            </li>
            <li v-if="hasPermission('api.testing.profile.positions') && testing.typeId && testing.typeId === TEST_TYPE_MAIN" class="tabs-3__nav-item">
              <a @click="tabSelect('positionTypes')" :class="'tabs-3__nav-link' + (tabs.positionTypes ? ' active' : '')" href="javascript:void(0)">{{ getTranslation('serviceType') }}</a>
            </li>
            <li v-if="hasPermission('api.testing.profile.positions') && testing.typeId && testing.typeId === TEST_TYPE_MAIN" class="tabs-3__nav-item">
              <a @click="tabSelect('registerPostTypes')" :class="'tabs-3__nav-link' + (tabs.registerPostTypes ? ' active' : '')" href="javascript:void(0)">{{ getTranslation('positionTypes') }}</a>
            </li>
          </ul>
          <div class="tabs-3__content  tabs-3__content--p-0">
            <div v-if="hasPermission('api.testing.profile.questions')" :class="'tabs-3__pane' + (tabs.questions ? ' active' : '')">
              <div class="row">
                <div class="col-md-12">
                  <QuestionsComponent :active="tabs.questions" :testing-id="testing.id"/>
                </div>
              </div>
            </div>
            <div v-if="hasPermission('api.testing.profile.nrkPositions')" :class="'tabs-3__pane' + (tabs.nrkPositions ? ' active' : '')">
              <div class="row">
                <div class="col-md-6">
                  <NrkResources :active="tabs.nrkPositions" :test-id="testing.id"/>
                </div>
              </div>
            </div>
            <div v-if="testing.typeId && TYPE_LAW === testing.typeId && hasPermission('api.testing.profile.positions')" :class="'tabs-3__pane' + (tabs.positions ? ' active' : '')">
              <div class="row">
                <div class="col-md-12">
                  <TestingPositionsComponent :active="tabs.positions" :test-id="testing.id"/>
                </div>
              </div>
            </div>
            <div v-if="testing.typeId && TEST_TYPE_MAIN === testing.typeId && hasPermission('api.testing.profile.positions')" :class="'tabs-3__pane' + (tabs.positionTypes ? ' active' : '')">
              <div class="row">
                <div class="col-md-6">
                  <PositionTypesComponent :position-types="testing.positionTypes"/>
                </div>
              </div>
            </div>
            <div v-if="testing.typeId && TEST_TYPE_MAIN === testing.typeId && hasPermission('api.testing.profile.positions')" :class="'tabs-3__pane' + (tabs.registerPostTypes ? ' active' : '')">
              <div class="row">
                <div class="col-md-6">
                  <RegisterPostTypeComponent :register-post-types="testing.registerPostTypes"/>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
    <!--  modal  -->
    <modal
        v-model="showModal"
        :modal-title="getTranslation('edit')"
        :ok-button-label="getTranslation('save')"
        :cancel-button-label="getTranslation('cancel')"
        @ok-button-click="updateTest"
        @cancelButtonClick="resetForm"
        @input="resetForm"
    >
      <form class="form w-100">
        <span class="text-danger">* {{ getTranslation('required') }}</span>
        <div class="form__group">
          <label class="form__label   form__label--block">{{ getTranslation('title') }}<span class="required">*</span></label>
          <input class="field field--full-width" :class="{'field--error': $v.form.titleRu.$error}" v-model.trim="form.titleRu" type="text">
          <div v-if="$v.form.titleRu.$error" class="form__error">{{ getTranslation('requiredField') }}<span class="required">*</span></div>
        </div>
        <div class="form__group">
          <label class="form__label   form__label--block">{{ getTranslation('titleKy') }}<span class="required">*</span></label>
          <input class="field field--full-width" :class="{'field--error': $v.form.titleKy.$error}" v-model.trim="form.titleKy" type="text">
          <div v-if="$v.form.titleKy.$error" class="form__error">{{ getTranslation('requiredField') }}<span class="required">*</span></div>
        </div>
        <div class="form__group">
          <label class="form__label   form__label--block">{{ getTranslation('type') }}<span class="required">*</span></label>
          <v-select
              v-model="form.type"
              :options="types"
              label="title"
              @search:blur="$v.form.typeId.$touch()"
              :class="{'field--error':$v.form.typeId.$error}"
          />
          <div v-if="$v.form.typeId.$error" class="form__error">{{ getTranslation('requiredField') }}<span class="required">*</span></div>
        </div>
        <div class="form__group">
          <label class="form__label   form__label--block" for="documentCode">{{ getTranslation('questionMinLimit') }}
            <span class="text-danger">*</span></label>
          <input disabled v-model="form.minLimit" id="minLimit" min="1" class="field field--full-width" type="number"/>
          <div v-if="$v.form.minLimit.$error" class="form__error">{{ getTranslation('requiredField') }}<span class="required">*</span></div>
        </div>
        <div class="form__group">
          <label class="form__label   form__label--block" for="documentCode">{{ getTranslation('documentCode') }}</label>
          <input v-model.number="form.documentCode" id="documentCode" min="0" class="field field--full-width" type="number"/>
        </div>
        <div v-if="form.typeId === TEST_TYPE_MAIN" class="row">

          <div class="form__group col-md-6">
            <label class="form__label">{{ getTranslation('positionType') }}</label>
            <div class="checkbox-group  form__group">
              <label class="checkbox types-checkbox">
                <input v-model="regPostAll" class="checkbox__input" type="checkbox"/>
                <span class="checkbox__indicator  checkbox__indicator--inline"></span>
                <span class="checkbox__label text--bold">{{ getTranslation('all') }}</span>
              </label>
            </div>
            <div class="checkbox-group  form__group">
              <label class="checkbox types-checkbox" v-for="regType in registerPostTypes" v-bind:key="regType.id">
                <input v-model="form.registerPostTypeIds" class="checkbox__input" type="checkbox" :value="regType.id"/>
                <span class="checkbox__indicator  checkbox__indicator--inline"></span>
                <span class="checkbox__label">{{ regType.title }}</span>
              </label>
            </div>
          </div>
          <div class="form__group col-md-6">
            <label class="form__label">{{ getTranslation('serviceType') }}</label>
            <div class="checkbox-group  form__group">
              <label class="checkbox types-checkbox">
                <input v-model="postAll" class="checkbox__input" type="checkbox"/>
                <span class="checkbox__indicator  checkbox__indicator--inline"></span>
                <span class="checkbox__label text--bold">{{ getTranslation('all') }}</span>
              </label>
            </div>
            <div class="checkbox-group  form__group">
              <label class="checkbox types-checkbox" v-for="positionType in positionTypes" v-bind:key="positionType.id">
                <input v-model="form.positionTypeIds" class="checkbox__input" type="checkbox" :value="positionType.id"/>
                <span class="checkbox__indicator  checkbox__indicator--inline"></span>
                <span class="checkbox__label">{{ positionType.title }}</span>
              </label>
            </div>
          </div>
          <div class="form__group col-md-6">
            <label class="form__label">{{ getTranslation('postGroup') }}</label>
            <div class="checkbox-group  form__group">
              <label class="checkbox types-checkbox">
                <input v-model="postGroupAll" class="checkbox__input" type="checkbox"/>
                <span class="checkbox__indicator  checkbox__indicator--inline"></span>
                <span class="checkbox__label text--bold">{{ getTranslation('all') }}</span>
              </label>
            </div>
            <div class="checkbox-group  form__group">
              <label class="checkbox types-checkbox" v-for="postGroup in postGroups" v-bind:key="postGroup.id">
                <input v-model="form.postGroupIds" class="checkbox__input" type="checkbox" :value="postGroup.id"/>
                <span class="checkbox__indicator  checkbox__indicator--inline"></span>
                <span class="checkbox__label">{{ postGroup.title }}</span>
              </label>
            </div>
          </div>
        </div>
        <div class="form__group">
          <label class="checkbox  checkbox--inline">
            <input class="checkbox__input" type="checkbox" v-model="form.status" :class="{'field--error':$v.form.status.$error}">
            <span class="checkbox__indicator  checkbox__indicator--inline"></span>
            <span class="checkbox__label">{{ getTranslation('status') }}</span>
            <span class="required">*</span>
          </label>
          <div v-if="$v.form.status.$error" class="form__error">{{ getTranslation('requiredField') }}<span class="required">*</span></div>
        </div>
      </form>
    </modal>
  </div>
</template>

<script>
import testingMixin from "./mixins/testing";
import QuestionsComponent from "./components/QuestionsComponent";
import required from "vuelidate/lib/validators/required";
import TestingPositionsComponent from "./components/PositionsComponent";
import NrkResources from "./components/NrkResources";
import PositionTypesComponent from "./components/PositionTypesComponent";
import RegisterPostTypeComponent from "./components/RegisterPostTypeComponent";

export default {
  name: "TestingView",
  components: {RegisterPostTypeComponent, PositionTypesComponent, NrkResources, TestingPositionsComponent, QuestionsComponent},
  mixins: [testingMixin],
  data() {
    return {
      showModal: false,
      TYPE_LAW: 1,
      tabs: {
        questions: false,
        positions: false,
        nrkPositions: false,
        positionTypes: false,
        registerPostTypes: false,
        postGroups: false
      }
    }
  },
  watch: {
    'form.type'(val) {
      if (val) {
        this.form.minLimit = val.QUESTION_MIN_LIMIT;
        this.form.typeId = val.id;
      }
    },
    'regPostAll'(val) {
      if (val && this.form.typeId === this.TEST_TYPE_MAIN) {

        for (let item of this.registerPostTypes)
          if (this.form.registerPostTypeIds.indexOf(item.id) < 0)
            this.form.registerPostTypeIds.push(item.id);
      } else
        this.form.registerPostTypeIds = [];
    },
    'postAll'(val) {
      if (val && this.form.typeId === this.TEST_TYPE_MAIN) {

        for (let item of this.positionTypes)
          if (this.form.positionTypeIds.indexOf(item.id) < 0)
            this.form.positionTypeIds.push(item.id);
      } else
        this.form.positionTypeIds = [];
    },
    'postGroupAll'(val) {
      if (val && this.form.typeId === this.TEST_TYPE_MAIN) {

        for (let item of this.postGroups)
          if (this.form.postGroupIds.indexOf(item.id) < 0)
            this.form.postGroupIds.push(item.id);
      } else
        this.form.postGroupIds = [];
    },
  },
  updated() {
    if (this.testing.title) {
      let actions = [];
      if (this.hasPermission('api.testing.update'))
        actions.push(
            {
              label: this.getTranslation('edit'),
              action: this.openEditModal,
              icon: {icon: '#icon__edit'}
            }
        );

      this.setHeadings({
        title: this.testing.title,
        breadcrumbs: [
          {
            label: this.getTranslation('testingTypes'),
            route: {name: 'api.testing.getList'}
          },
          {
            label: this.testing.type.title
          }
        ],
        toBack: {
          label: this.getTranslation('backToTestingTypeList'),
          route: {name: 'api.testing.getList'}
        },
        actions: actions
      });
    }
  },
  created() {
    this.fetchTesting().then(() => {
      this.fetchFormOptions().then(() => {
        this.loadSelects = true;
      });

      this.tabSelect(null, 'questions');
    })
  },
  methods: {
    updateTest() {
      this.$v.form.$touch();
      if (!this.$v.form.$invalid)
        this.updateTesting();
      else
        this.snotifyError('wrongFormMsg');
    },
    openEditModal() {
      this.form.id = this.testing.id;
      this.form.status = this.testing.status;
      this.form.minLimit = this.testing.minLimit;
      this.form.typeId = this.testing.typeId;
      this.form.type = this.types.filter(item=>item.id===this.testing.typeId)[0];
      this.form.titleRu = this.testing.titleRu;
      this.form.titleKy = this.testing.titleKy;
      this.form.documentCode = this.testing.documentCode;
      this.form.postGroupIds = [];
      this.form.registerPostTypeIds = [];
      this.form.positionTypeIds = [];

      if (this.testing.typeId === this.TEST_TYPE_MAIN) {

        for (let item of this.testing.registerPostTypes) {
          if (this.form.registerPostTypeIds.indexOf(item.resourceId) < 0)
            this.form.registerPostTypeIds.push(item.resourceId);
        }

        for (let item of this.testing.postGroups) {
          if (this.form.postGroupIds.indexOf(item.resourceId) < 0)
            this.form.postGroupIds.push(item.resourceId);
        }

        for (let item of this.testing.positionTypes) {
          if (this.form.positionTypeIds.indexOf(item.resourceId) < 0)
            this.form.positionTypeIds.push(item.resourceId);
        }

        if (this.form.positionTypeIds.length === this.positionTypes.length && this.form.positionTypeIds.length !== 0)
          this.postAll = true;
        else if (this.form.positionTypeIds.length === 0)
          this.postAll = false;

        if (this.form.registerPostTypeIds.length === this.registerPostTypes.length && this.form.registerPostTypeIds.length !== 0)
          this.regPostAll = true;
        else if (this.form.registerPostTypeIds.length === 0)
          this.regPostAll = false;

        if (this.form.postGroupIds.length === this.postGroups.length && this.form.postGroupIds.length !== 0)
          this.postGroupAll = true;
        else if (this.form.postGroupIds.length === 0)
          this.postGroupAll = false;

      } else {
        this.form.registerPostTypeIds = [];
        this.form.positionTypeIds = [];
        this.form.postGroupIds = [];
      }

      this.showModal = true;
    },
  },
  validations: {
    form: {
      titleRu: {
        required
      },
      titleKy: {
        required
      },
      status: {
        required
      },
      typeId: {
        required
      },
      minLimit: {
        required
      }
    }
  }
}
</script>

<style scoped>
.types-checkbox {
  position: relative;
  display: -ms-flexbox;
  display: -webkit-box;
  display: flex;
  -ms-flex-direction: row;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  flex-direction: row;
  -ms-flex-align: center;
  -webkit-box-align: center;
  align-items: center;
  -ms-flex-wrap: wrap;
  flex-wrap: nowrap !important;
  margin-right: 15px;
  margin-bottom: 8px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  cursor: pointer;
}
</style>
